module.exports = __webpack_public_path__ + "img/logo-2.ac13f449.png";